import gql from 'graphql-tag';
const PAINTED_FINGER_CLUE_ACTIVITY_FRAGMENT = gql `
  fragment PaintedFingerClueActivityFragment on PaintedFingerClueActivity {
    rounds {
      roundIndex
      letters
      steps {
        stepIndex
        answer
      }
    }
  }
`;
export default PAINTED_FINGER_CLUE_ACTIVITY_FRAGMENT;
